import { FC, MutableRefObject } from 'react'
import { getStyledSectionWrapper } from '../../styled-components/SectionWrapper.styled'
import { SectionWrapper } from '../wrappers/SectionWrapper.component';
import { AboutSectionCardHolder } from './AboutSectionCardHolder.component';
import { AboutTitleContent } from './AboutTitleContent.component';

export interface AboutSectionProps {
    refItem: MutableRefObject<any>
}

export const AboutSection: FC<AboutSectionProps> = ({ refItem }) => {

    const StyledSectionWrapper = getStyledSectionWrapper(170)
    return (
        <StyledSectionWrapper ref={refItem}>
            <SectionWrapper >
                <div>
                    <AboutTitleContent />
                    <AboutSectionCardHolder />
                </div>
            </SectionWrapper>
        </StyledSectionWrapper>
    )
}